import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const HuddleIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescInclusion">Group of people in a huddle</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M46.8 89.2a33.2 33.2 0 0 1 3.1-13.5 47.5 47.5 0 0 1 23-24 2.5 2.5 0 0 1 3.8 2 2.4 2.4 0 0 1-.8 2A50 50 0 0 0 61.7 78a1.3 1.3 0 0 1-.8.9 11 11 0 0 0-7 9.7 11 11 0 0 0 5.8 11 3 3 0 0 1 1.5 1.6 33.6 33.6 0 0 0 9 14 2.9 2.9 0 0 1 .7 3.1 3 3 0 0 1-2.5 2.1 3.3 3.3 0 0 1-2.3-.5 41.7 41.7 0 0 1-15.2-15.6 30.3 30.3 0 0 1-3.7-10.8l-.4-4.3Z"
        className="accent"
      />
      <path
        d="M82.7 147.9a30 30 0 0 1-18.8-6.6 47.6 47.6 0 0 1-17.7-29.1 24 24 0 0 1-.4-2.6 2.5 2.5 0 0 1 2-2.5 2.5 2.5 0 0 1 2.9 1.4 49.3 49.3 0 0 0 9 13.5 48.1 48.1 0 0 0 7.9 6.9 1 1 0 0 1 .4 1 11.4 11.4 0 0 0 19.2 7.6 3.2 3.2 0 0 1 2.3-1 32.5 32.5 0 0 0 15.6-4 3.2 3.2 0 0 1 4.2.8 3.2 3.2 0 0 1-.6 4.3 40.8 40.8 0 0 1-20 9.7l-6 .8Z"
        className="accent"
      />
      <path
        d="M101.3 154.7a55.5 55.5 0 0 1-8.6-1 2.5 2.5 0 0 1-2-2.5 2.5 2.5 0 0 1 2.2-2.4 46 46 0 0 0 8.8-1.8 50 50 0 0 0 16-8 .8.8 0 0 1 .7-.1 11.4 11.4 0 0 0 14.4-9.8 11 11 0 0 0-1-6.2 2.7 2.7 0 0 1-.2-2.1 32 32 0 0 0 1.5-11.2 53 53 0 0 0-.6-5.3 3.1 3.1 0 0 1 5.3-2.8 4 4 0 0 1 .8 1.1 40.2 40.2 0 0 1 3.3 14 37.6 37.6 0 0 1-2 15 29.1 29.1 0 0 1-10.5 14 46.8 46.8 0 0 1-21.6 8.6l-6.4.5Zm1.4-110A47.6 47.6 0 0 1 135.4 58l1.6 1.6a2.5 2.5 0 0 1 0 3.2 2.5 2.5 0 0 1-3.1.7 48.4 48.4 0 0 0-19-6.2c-2.3-.3-4.6-.3-6.8-.4a1 1 0 0 1-.7-.3c-3.1-3.6-7-5-11.7-4s-7.5 4.5-8.5 9.2a2.5 2.5 0 0 1-1 1.7 33.4 33.4 0 0 0-10.7 13 3 3 0 0 1-3.2 1.5 3 3 0 0 1-2.6-2.4 4 4 0 0 1 0-1.6 41.6 41.6 0 0 1 10.6-19.5A30 30 0 0 1 96 45.4a29.5 29.5 0 0 1 6.6-.7Z"
        className="accent"
      />
      <path
        d="M118.4 63a41 41 0 0 1 21.8 6.3A29.3 29.3 0 0 1 153 86.8a48.4 48.4 0 0 1 1.8 15.5 47.5 47.5 0 0 1-5.6 20.3 2.5 2.5 0 0 1-3.2 1.3 2.6 2.6 0 0 1-1.5-3.1c.4-2.5.8-5 1-7.5a48.2 48.2 0 0 0-2.8-18.8 1 1 0 0 1 .2-1 11.4 11.4 0 0 0-8-17.4 15.5 15.5 0 0 0-3.2 0 2.8 2.8 0 0 1-2-.5 33.5 33.5 0 0 0-13.1-5.7 25 25 0 0 0-2.2-.4 3 3 0 0 1-2.8-2.9 3 3 0 0 1 2.4-3.2l4.4-.4Zm-29.4.7a9.4 9.4 0 1 1 9.4 9.5 9.4 9.4 0 0 1-9.4-9.5ZM55.8 89.5a9.4 9.4 0 1 1 9.4 9.5 9.5 9.5 0 0 1-9.4-9.5Z"
        className="accent"
      />
      <path
        d="M133.2 96.8a9.4 9.4 0 1 1 9.5-9.4 9.4 9.4 0 0 1-9.5 9.4Zm-11.7 40.4a9.4 9.4 0 1 1 9.4-9.4 9.5 9.5 0 0 1-9.4 9.4ZM70 129a9.4 9.4 0 1 1 9.4 9.5A9.4 9.4 0 0 1 70 129Z"
        className="accent"
      />
    </Icon>
  );
};

export default HuddleIcon;
